// extracted by mini-css-extract-plugin
module.exports = {"sliderSection":"Slider_sliderSection__8dZY9","content":"Slider_content__nknix","left":"Slider_left__ZwLpo","right":"Slider_right__rY4I8","subtitle":"Slider_subtitle__NrL3u"};